module.exports = __webpack_public_path__ + "static/media/Decoration_Ufo.12704cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_Ufo.png
// module id = 1351
// module chunks = 3